import {IBannerData} from "./IBannerData";

export class BannerDataIframeNull implements IBannerData {
    static IFRAME_NULL: BannerDataIframeNull = new BannerDataIframeNull();
}
